module.exports = __webpack_public_path__ + "static/riah_logo-3bac90e2b94d242463144df4b4da86cc.webp";